<dd>
  <input type="checkbox" name="{{prefix}}[email_sign_up]" id="email_sign_up" value="1" />
  <label for="email_sign_up">Yes, send me e-mails with news and exclusive offers.</label>
</dd>
